import { memo } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useTranslation } from 'react-i18next';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { ProductTemplatePreviewDialog } from 'modules/inventory/settings/product-templates/components/ProductTemplatePreview';
import { useDeleteProductTemplate } from 'modules/inventory/settings/product-templates/hooks/useDeleteProductTemplate';

type ProductTemplateRowActionsProps = {
  rowId: string;
};

const ProductTemplateRowActions = ({ rowId }: ProductTemplateRowActionsProps) => {
  const { t } = useTranslation('productTemplates');
  const { isOpen, onClose, onOpen } = useToggle();
  const { isOpen: previewOpen, onClose: onPreviewClose, onOpen: onPreviewOpen } = useToggle();
  const handleEdit = useParamsLink({ edit: rowId });
  const { mutate, isLoading, error } = useDeleteProductTemplate(rowId, onClose);

  return (
    <Stack direction='row' spacing={1}>
      <Tooltip title={t('preview.open')}>
        <IconButton size='small' onClick={onPreviewOpen}>
          <VisibilityOutlinedIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      <EditRowActions onClick={handleEdit} />
      <DeleteRowAction
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        error={error}
        isLoading={isLoading}
        onDelete={mutate}
      />
      <ProductTemplatePreviewDialog open={previewOpen} templateId={rowId} onClose={onPreviewClose} />
    </Stack>
  );
};

export default memo(ProductTemplateRowActions);
